/**
 * Account panel state management
 */
export default {
    namespaced: true,

    state: {
        attempts: 0,
    },

    getters: {
    },

    mutations: {
    },

    actions: {
        track(context, event) {
            // If Intercom isn't loaded yet, try again in a bit...
            if ( typeof Intercom === 'undefined' ) {
                return new Promise((resolve, reject) => {
                    if ( context.state.attempts < 30 ) {
                        context.state.attempts++;

                        setTimeout(() => {
                            context.dispatch('track', event)
                                   .then(() => {
                                        resolve();
                                   })
                                   .catch(() => {
                                        reject();
                                   });
                        }, 500);
                    } else {
                        reject();
                    }
                });
            }

            Intercom('trackEvent', event.type, (event.meta) ? event.meta : {});
            context.state.attempts = 0;
            return true;
        },
        shutdown(context) {
            // If Intercom isn't loaded yet, try again in a bit...
            if ( typeof Intercom === 'undefined' ) {
                return new Promise((resolve, reject) => {
                    if ( context.state.attempts < 30 ) {
                        context.state.attempts++;

                        setTimeout(() => {
                            context.dispatch('shutdown')
                                .then(() => {
                                    resolve();
                                })
                                .catch(() => {
                                    reject();
                                });
                        }   , 500);
                    } else {
                        reject();
                    }
                });
            }

            Intercom('shutdown');
            context.state.attempts = 0;
            return true;
        },
        openNewChat(context, event) {
            Intercom('showNewMessage');
        }
    },
};
